import type { ReactNode } from 'react';
import { motion } from 'motion/react';

interface TrocaFadeProps {
  /** Muda quando a lista troca (aba, filtro). É o que dispara o fade. */
  chave: string;
  children: ReactNode;
  className?: string;
}

// Troca de conteúdo com fade curto de 120 ms — sem deslocar nada, para
// listas longas (inscritos, equipe, compradores) continuarem rápidas.
export default function TrocaFade({ chave, children, className = '' }: TrocaFadeProps) {
  return (
    <motion.div
      key={chave}
      className={className}
      initial={{ opacity: 0.35 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.12, ease: 'linear' }}
    >
      {children}
    </motion.div>
  );
}